// src/lib/book-image.ts

export type ResolvedImage = { src: string; alt: string };

const GENERATED_IMAGE_FALLBACKS = ['/default-book-cover.svg', '/untangled-logo.svg'];

export function isGeneratedImageFallback(src?: string | null) {
  const value = String(src || '').trim();
  return !value || GENERATED_IMAGE_FALLBACKS.some((fallback) => value.endsWith(fallback) || value.includes(fallback));
}

export function getUploadedImage(src?: string | null, alt?: string | null, fallbackAlt = 'Image'): ResolvedImage | null {
  const cleanSrc = String(src || '').trim();
  if (isGeneratedImageFallback(cleanSrc)) return null;
  return { src: cleanSrc, alt: alt?.trim() || fallbackAlt };
}

export function getBookCover(
  _coverImageId?: string | null,
  coverImageUrl?: string | null,
  coverImageAlt?: string | null,
  title?: string | null,
  defaultCover?: ResolvedImage | null,
): ResolvedImage | null {
  return getUploadedImage(coverImageUrl, coverImageAlt, title?.trim() || 'Book cover') ?? defaultCover ?? null;
}
